
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
    selector: 'kon-phone-number-type',
    imports: [InputMaskModule, ReactiveFormsModule],
    template: ` <p-inputMask
    #phoneNumber
    mask="(+999) 999-999-999"
    [formControl]="$any(formControl)"
    placeholder="(+421) 000-000-000"
  ></p-inputMask>`,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyPhoneNumberTypeComponent extends FieldType<FormlyFieldConfig> {}
